/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },
    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./views/pages/Dashboard.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/dashboard' }],
            pageTitle: 'Dashboard'
          }
        },
        {
          path: '/luminarias',
          name: 'luminarias',
          component: () => import('./views/pages/Luminarias/Header.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'Luminarias List', active: true}
            ],
            pageTitle: 'Luminarias'
          }
        },
        {
          path: '/luminarias/:uuid',
          name: 'luminarias-detail',
          component: () => import('./views/pages/Luminarias/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'Luminarias Detalle', active: true}
            ],
            pageTitle: 'Luminarias'
          }
        },
        {
          path: '/luminarias/:uuid/history',
          name: 'luminarias-history',
          component: () => import('./views/pages/Luminarias/History.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'Luminarias Historico', active: true}
            ],
            pageTitle: 'Luminarias'
          }
        },
        {
          path: '/luminarias/:uuid/statistics',
          name: 'luminarias-statistics',
          component: () => import('./views/pages/Luminarias/Statistics.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'Luminarias Estadísticas', active: true}
            ],
            pageTitle: 'Luminarias'
          }
        },
        {
          path: '/map',
          name: 'map',
          component: () => import('./views/pages/Map.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/map' }],
            pageTitle: 'Map'
          }
        },
        {
          path: '/circuitos',
          name: 'circuitos',
          component: () => import('./views/pages/Circuitos/Header.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'Circuitos List', active: true}
            ],
            pageTitle: 'Circuitos'
          }
        },
        {
          path: '/circuitos/add',
          name: 'circuitos-add',
          component: () => import('./views/pages/Circuitos/Add.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'Agregar Circuitos', active: true}
            ],
            pageTitle: 'Circuitos'
          }
        },
        {
          path: '/circuitos/:uuid',
          name: 'circuitos-detail',
          component: () => import('./views/pages/Circuitos/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'Detalle Circuitos', active: true}
            ],
            pageTitle: 'Circuitos'
          }
        },
        {
          path: '/circuitos/:uuid/config',
          name: 'circuitos-config',
          component: () => import('./views/pages/Circuitos/Config.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'Configuracion Circuitos', active: true}
            ],
            pageTitle: 'Circuitos'
          }
        },
        {
          path: '/circuitos/:uuid/assign',
          name: 'circuitos-assign',
          component: () => import('./views/pages/Circuitos/Assign.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'Asignar Luminarias', active: true}
            ],
            pageTitle: 'Asignar Luminarias'
          }
        }
      ]
    },
    
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  if (store.state.AppActiveUser.token.length > 0) {
    if (to.path === '/' || to.path === '/forgot-password' || (store.state.AppActiveUser.userRole !== 'MA' && to.matched.some(record => record.meta.rule === 'admin'))) {
      window.location.href = '/menu'
    } else {
      next()
    }
  } else if (to.path === '/' || to.path === '/forgot-password') {
    next()
  } else {
    window.location.href = '/'
  }

})

export default router
